export default "__VITE_ASSET__C97U5oGc__"